import { isEmpty, isNotEmpty } from '@/pipes';
import { UserProfileModel } from '../UserProfileModel';
import { CoachResumeModel } from './CoachResumeModel'
import { StaffMember } from '../team/StaffMember';

export class CoachProfileModel extends UserProfileModel {
	sports: string[] = [];
	country: string = "";
	resume?: CoachResumeModel;
	teams: string[] = [];			// ids of coach teams used for display order

	load(obj: Partial<CoachProfileModel>): this {
		Object.assign(this, obj);
		if (obj['resume'] !== undefined){
			this.resume = new CoachResumeModel().load(obj['resume']);
		} 
		else {
			this.resume = new CoachResumeModel();
		}
		return this;
	}
	loadFromStaff(obj: Partial<StaffMember>): this {
		if( isEmpty(obj) ) return this;
		
		if( isEmpty(this.id) ) this.id = obj.coachId;
		this.firstName = obj.firstName;
		this.lastName = obj.lastName;
		this.email = obj.email;
		this.pictureUrl = obj.pictureUrl;
		return this;
	}

	get SportName(): string {
		if( !!this.sports && this.sports.length > 0 ) return this.sports[0];
		return "Sport";
	}
	get HasTeamsOrder(): boolean {
		return isNotEmpty(this.teams);
	}
}

export type PartialCoachProfile = Partial<CoachProfileModel> & { id: string };